import { all, call, put, select, takeLatest } from "@redux-saga/core/effects";
import { RootState } from "../../app/Store";
import * as Showpath from "../ShowpathProxy";
import * as StoryInfo from "../StoryInfoProxy";
import { loadStoryDetails, storyDetailsLoaded } from "./StoryDetailsReducer";

function* fetchStoryDetails(): unknown {
  // select reads from the Redux store — no direct store access needed
  const userId: number = yield select(
    (state: RootState) => state.listenerProfile.userId
  );

  // call wraps the async function — saga handles the await for us
  const response: Showpath.ShowPathResponse = yield call(
    Showpath.getShowPath,
    userId
  );

  const storyTracks = Object.values(response.tracks).filter(
    (track) => track.track_type === "story"
  );

  // all runs multiple calls in parallel, like Promise.all
  const stories: StoryInfo.StoryResult[] = yield all(
    storyTracks.map((track) => call(StoryInfo.getStoryInfo, track.track_id))
  );

  // put dispatches an action — this updates the reducer
  yield put(storyDetailsLoaded(stories));
}

// reactions is the convention in this codebase for "what actions does this saga watch for"
export function* reactions() {
  yield takeLatest(loadStoryDetails.type, fetchStoryDetails);
}
